import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchAllProductsByFilters, fetchAllProductsCategory, fetchProductByProductId } from "./ProductList_API";

const initialState = {
    products: [],
    status: "idle",
    totalItems: 0,
    parentCateogories: [],
    subCategories: [],
    productFullView: {}
}

export const fetchAllProductsByFiltersAsync = createAsyncThunk(
    "product/fetchAllProductsByFilters",
    async ({ filter, sort, pagination, search }) => {
        const response = await fetchAllProductsByFilters(filter, sort, pagination, search);
        return response.data;
    }
);

export const fetchAllProductsCategoryAsync = createAsyncThunk(
    "product/fetchAllProductsCategory",
    async () => {
        const response = await fetchAllProductsCategory();
        return response
    }
)

export const fetchProductByProductIdAsync = createAsyncThunk(
    "product/fetchProductByProductId",
    async (productId) => {
        const response = await fetchProductByProductId(productId);
        return response
    }
)


export const ProductList_Slice = createSlice({
    name: "product",
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllProductsByFiltersAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAllProductsByFiltersAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.products = action.payload.products;
                state.totalItems = action.payload.totalItems;
            })
            .addCase(fetchAllProductsCategoryAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAllProductsCategoryAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.parentCateogories = action.payload.filter(category => category.parentId === null);
                state.subCategories = action.payload.filter(category => category.parentId !== null);
            })
            .addCase(fetchProductByProductIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchProductByProductIdAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.productFullView = action.payload;
            })

    }
})
export const selectAllProducts = (state) => state.product.products;
export const selectedProductById = (state) => state.product.productFullView;
export default ProductList_Slice.reducer;